import { EventBus } from './EventBus.js';
export const defaultEventBus = new EventBus();
//# sourceMappingURL=defaultEventBus.js.map